export const AxisX = props => {
    const { position, x, y, text } = props
    const style = { textAnchor: 'end' , 'fill': '#000'  }
    return (
        <g className='axis axis--x' transform={ position }>
            <text
                className='label'
                x={ x }
                y={ y }
                style={ style }
            >{ text }</text>
        </g>
    )
}

export const AxisY = props => {
    const { position, transformText, x , y, dy, text } = props
    const style = { textAnchor: 'end' , 'fill': '#000'  }
    return (
        <g className='axis axis--y' transform={ position }>
            <text
                className='label'
                transform={ transformText }
                x={ x }
                y={ y }
                dy={ dy }
                style={ style }
            >{ text }</text>
        </g>
    )
}
